/* istanbul ignore file */
import React from 'react';

import * as styles from './Navigation.styles';

interface NavigationProps {
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  navItems: {
    title: string;
    id: string;
  }[];
}

export const Navigation = ({ onLinkClick, navItems }: NavigationProps) => {
  return (
    <div css={styles.container}>
      <ul css={styles.navItemList}>
        {navItems.map(({ title, id }) => (
          <li css={styles.navItem} key={id}>
            <a onClick={onLinkClick} href={`#${id}`}>
              {title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
